<template>
  <table class="listado table table-hover tablaOfertas">
    <thead class="bg-primary text-white">
      <!-- 1. Descripción -->
      <th-ordenado title="Descripción" campo="descripcion" />
      <!-- 2. Cliente -->
      <th-ordenado title="Cliente" campo="cliente" v-show="colVisible('cliente')" />
      <!-- 3. Campaña -->
      <th-ordenado title="Campaña" campo="campania" v-show="colVisible('campania')" />
      <!-- 4. Sector -->
      <th-ordenado title="Sector" campo="sector" v-show="colVisible('sector')" />
      <!-- 5. Días -->
      <th-ordenado title="Días" campo="diasGestion" v-show="colVisible('numDias')">
        <v-icon name="calendar" width="16" v-b-tooltip.hover title="Días en gestión desde la oferta original" />
      </th-ordenado>
      <!-- 6. Estado -->
      <th-ordenado title="Estado" campo="estado" v-show="colVisible('estado')" class="text-center" />
      <!-- 7. Embudo -->
      <th-ordenado title="Embudo" campo="pipelineName" v-show="colVisible('pipe')" class="text-center" />
      <!-- 8. Etapa -->
      <th-ordenado title="Etapa" campo="stageName" v-show="colVisible('pipe')" class="text-center" />
      <!-- 9. Ver -->
      <th-ordenado title="Ver." campo="numeroVersion" v-show="colVisible('version')" class="text-center" width="80" />
      <!-- 10. Fecha de la oferta -->
      <th-ordenado title="F/Oferta" campo="fecha" v-show="colVisible('fecha')" />
      <!-- 11. Fecha de firma -->
      <th-ordenado title="F/Firma" campo="fechaFirmaContrato" v-show="colVisible('fechaFirmaContrato')" />
      <!-- 12. Días de cierre -->
      <th-ordenado title="Dias/Firma" campo="diasParaFirmaContrato" v-show="colVisible('diasParaFirmaContrato')" />
      <!-- 13. Propietario -->
      <th-ordenado title="Propietario" campo="comercial" v-show="colVisible('propietario')" />
      <!-- 14. Plan -->
      <th-ordenado title="Plan" campo="plan" width="90" v-show="colVisible('plan')" />
      <!-- 15. Forma de pago -->
      <th title="Forma de pago" width="120" v-show="colVisible('formaPagoCuota')">F/Pago</th>
      <!-- 16. Duración del contrato -->
      <th title="Duración del contrato" width="120" v-show="colVisible('duracionContrato')">D/Contr.</th>
      <!-- 17. Información adicional -->
      <th title="Información adicional" width="120" v-show="colVisible('info')">Info.</th>
      <!-- 18. MRR -->
      <th-ordenado
        title="€ Cuota"
        campo="totalCuotaAnualEnEuros"
        v-show="colVisible('totalCuotaAnualEnEuros')"
        nowrap
      />
      <!-- 19. ARR -->
      <th-ordenado
        title="€ Servicios"
        campo="totalServiciosEnEuros"
        v-show="colVisible('totalServiciosEnEuros')"
        nowrap
      />
      <!-- 20. Acciones -->
      <th class="th-acciones">Acciones</th>
    </thead>
    <tbody>
      <tr
        v-for="oferta in ofertas"
        :key="oferta.id"
        :class="{ resaltada: ultimaOfertaModificada == oferta.id }"
        role="button"
      >
        <!-- 1. Nombre  -->
        <td @click="editarOferta(oferta.id)">
          <div class="desc-oferta" :title="oferta.descripcion">
            {{ recortar(oferta.descripcion) }}
          </div>
          <small class="desc-oferta text-secondary" title="oferta.cliente"> ({{ recortar(oferta.cliente) }}) </small>
        </td>
        <!-- 2. Cliente  -->
        <td @click="editarOferta(oferta.id)" v-show="colVisible('cliente')">
          {{ oferta.cliente }}
        </td>
        <!-- 3. Campaña -->
        <td @click="editarOferta(oferta.id)" v-show="colVisible('campania')">
          <div class="text-info">
            {{ oferta.campania }}
          </div>
          <div>{{ oferta.pais }}</div>
        </td>
        <!-- 4. Sector -->
        <td @click="editarOferta(oferta.id)" v-show="colVisible('sector')">
          <div class="text-info">
            {{ oferta.sector }}
          </div>
        </td>
        <!-- 5. Días en gestión -->
        <td v-show="colVisible('numDias')" :class="colorDias(oferta.diasGestion)" @click="editarOferta(oferta.id)">
          {{ oferta.diasGestion || "-" }}
        </td>
        <!-- 6. Estado oferta -->
        <td @click="editarOferta(oferta.id)" v-show="colVisible('estado')" class="text-center">
          <b-badge :variant="varianteParaEstado(oferta)">
            {{ oferta.estado }}<br />
            {{ fechaRelevante(oferta) }}
          </b-badge>
          <div v-if="oferta.caducada">
            <b-badge variant="danger">caducada</b-badge>
          </div>
        </td>
        <!-- 7. Embudo -->
        <td @click="editarOferta(oferta.id)" v-show="colVisible('pipe')" class="text-center">
          {{ limpiarEmbudo(oferta.pipelineName) }}
        </td>
        <!-- 8. Etapa -->
        <td @click="editarOferta(oferta.id)" v-show="colVisible('pipe')" class="text-center">
          {{ oferta.stageName }}<br />
          <b-badge :variant="varianteParaEstadoPipe(oferta.dealStatus)" pill>
            {{ oferta.dealStatus }}
          </b-badge>
        </td>
        <!-- 9. Versión -->
        <td @click="editarOferta(oferta.id)" v-show="colVisible('version')" class="text-center">
          {{ oferta.numeroVersion }}
        </td>
        <!-- 10. Fecha de oferta -->
        <td @click="editarOferta(oferta.id)" v-show="colVisible('fecha')" class="text-center">
          {{ formatFecha(oferta.fecha) }}
        </td>
        <!-- 11. Fecha prevista de firma -->
        <td @click="editarOferta(oferta.id)" v-show="colVisible('fechaFirmaContrato')" class="text-center">
          {{ formatFecha(oferta.fechaFirmaContrato) }}
        </td>
        <!-- 12. Días para firma -->
        <td @click="editarOferta(oferta.id)" v-show="colVisible('diasParaFirmaContrato')" class="text-center">
          <span :class="colorDiasParaFirma(oferta.diasParaFirmaContrato)">
            {{ formatDiasFirmaContrato(oferta) }}
          </span>
        </td>
        <!-- 13. Propietario -->
        <td @click="editarOferta(oferta.id)" v-show="colVisible('propietario')">
          {{ oferta.comercial }}
        </td>
        <!-- 14. plan -->
        <td @click="editarOferta(oferta.id)" v-show="colVisible('plan')" class="text-center">
          {{ oferta.plan }} - {{ oferta.divisa }}
        </td>
        <!-- 15. formaPago de la cuota -->
        <td @click="editarOferta(oferta.id)" v-show="colVisible('formaPagoCuota')">
          {{ oferta.nombreTipoCuota }}
        </td>
        <!-- 16. duracionContrato -->
        <td @click="editarOferta(oferta.id)" v-show="colVisible('duracionContrato')">
          {{ oferta.duracionContrato }}
        </td>
        <!-- 17. Información adicional -->
        <td v-show="colVisible('info')" class="text-center">
          {{ nombreTipoVenta(oferta.tipoVenta) }}
          <b-badge>
            <a :href="oferta.pipedrive" class="text-white" title="Abrir en pipedrive" target="_blank">
              {{ oferta.origen }}
            </a>
          </b-badge>
        </td>
        <!-- 18. totalCuotaAnual -->
        <td @click="editarOferta(oferta.id)" v-show="colVisible('totalCuotaAnualEnEuros')" class="text-right">
          {{ prepararImporte(oferta.totalCuotaAnualEnEuros) }}€
        </td>
        <!-- 19. totalServicios -->
        <td @click="editarOferta(oferta.id)" v-show="colVisible('totalServiciosEnEuros')" class="text-right">
          {{ prepararImporte(oferta.totalServiciosEnEuros) }}€
        </td>
        <!-- 20. Acciones -->
        <td nowrap="nowrap" class="td-acciones">
          <slot name="botonera" :oferta="oferta">
            <botonera-acciones-tabla-ofertas :oferta="oferta" @ofertaCambiada="ofertaCambiada" />
          </slot>
        </td>
      </tr>
    </tbody>
    <tfoot v-if="!ofertas.length">
      <sin-registros :count="ofertas.length" :colspan="10" />
    </tfoot>
  </table>
</template>
<script>
import { mapState } from "pinia";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";

import BotoneraAccionesTablaOfertas from "./BotoneraAccionesTablaOfertas.vue";
import { formatDateTabla, formatDateSinZona } from "@/services/date";
import { variantePorEstado as varianteParaEstadoPipe } from "@/services/pipedrive";

import * as TipoVenta from "@/enums/TipoVenta";
export default {
  components: {
    BotoneraAccionesTablaOfertas,
  },
  props: {
    ofertas: {
      type: Array,
      required: true,
    },
    columnasVisibles: {
      type: Array,
      default() {
        return ["campania", "numDias", "estado", "pipe", "version", "fecha", "propietario", "plan", "info"];
      },
    },
  },
  computed: {
    ...mapState(useOfertaFormStore, ["ultimaOfertaModificada"]),
  },
  methods: {
    colVisible(name) {
      return this.columnasVisibles.includes(name);
    },
    varianteParaEstadoPipe(estado) {
      return varianteParaEstadoPipe(estado);
    },
    limpiarEmbudo(embudo) {
      return embudo.replace(/^[\*\s]+/g, "");
    },
    colorDias(dias) {
      if (dias >= 30) {
        return "texto-dias-negativo";
      } else {
        return "texto-dias-positivo";
      }
    },
    colorDiasParaFirma(dias) {
      if (dias <= 30) {
        return "texto-dias-proximo";
      } else {
        return "texto-dias-lejano";
      }
    },
    recortar(texto) {
      let chars = 100;
      texto = texto.replace(/_/g, " ");
      if (texto.length > chars) {
        return texto.substring(0, chars) + "...";
      } else {
        return texto;
      }
    },
    fechaRelevante(oferta) {
      return formatDateTabla(oferta.fechaRelevante);
    },
    formatFecha(fecha) {
      if (!fecha) {
        return "-";
      }
      let fechaLimpia = formatDateSinZona(fecha);
      return formatDateTabla(fechaLimpia);
    },
    formatDiasFirmaContrato(oferta) {
      if (oferta.ganada || oferta.perdida || oferta.diasParaFirmaContrato < 0) {
        return "-";
      }

      return oferta.diasParaFirmaContrato;
    },
    calculaDias(fecha, estado, ganadaEl, perdidaEl) {
      let origen = new Date(formatDateSinZona(fecha));
      let fin = new Date(Date.now());

      if ((estado == "Ganada" && ganadaEl == "") || (estado == "Perdida" && perdidaEl == "")) {
        return "-";
      }

      if (estado == "Ganada" && ganadaEl != "") {
        fin = new Date(formatDateSinZona(ganadaEl));
      }

      if (estado == "Perdida" && perdidaEl != "") {
        fin = new Date(formatDateSinZona(perdidaEl));
      }

      let resta = fin.getTime() - origen.getTime();
      return Math.round(resta / (1000 * 60 * 60 * 24));
    },
    ofertaCambiada(id) {
      this.$emit("ofertaCambiada", id);
    },
    varianteParaEstado(oferta) {
      switch (oferta.estado) {
        case "Ganada":
          return "success";
        case "Perdida":
          return "danger";
        case "Entregada":
          return "warning";
        case "Visada":
          return "info";
        case "Caducada":
          return "dark";
      }
      return "";
    },
    editarOferta(ofertaId) {
      this.$router.push("/ofertas/editar/" + ofertaId);
    },
    nombreTipoVenta(tipo) {
      return TipoVenta.nombreCorto(tipo);
    },
    prepararImporte(value) {
      const options = { maximumFractionDigits: 0, useGrouping: true };
      return Intl.NumberFormat("es-ES", options).format(Math.round(value));
    },
  },
  data() {
    return {
      searchOfertas: "",
      sortKey: "name",
      reverse: false,
    };
  },
};
</script>
<style>
@media (max-width: 1576px) {
  .desc-oferta {
    font-size: 0.8em;
    max-width: 100px;
    max-height: 64px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.estado-caducada {
  font-size: 0.7em;
  text-align: center;
}
</style>
